import React, { Component } from "react";
import service from "../services";
import Loader from "./loader";
import TextField from "./TextField";
import CheckBox from "./CheckBox";
import Dropdown from "./Dropdown";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import swal from "sweetalert";
import SimpleReactValidator from "simple-react-validator";
import DraggerIcon from "../icons/draggericon";
import EditIcon from "../icons/EditIcon";
import DeleteIcon from "../icons/DeleteIcon";
import CalendarIcon from "../icons/calendaricon";
import moment from "moment-timezone";

/*
 * FooterConfiguration Component
 *
 * Displays footer sections with links in an accordion view.
 * - Sections: Add/Edit/Delete, max 6
 * - Links: Add/Edit with conditional source UI (Native = date pickers, Inherited = dateConfig dropdown), DnD reordering
 */
const MAX_SECTIONS = 6;

class FooterConfiguration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderFlag: false,
      footerSections: [],
      dateConfigurations: [], // For inherited source dropdown

      // Link Modal state
      showModal: false,
      modalMode: "add", // "add" or "edit"
      editingLink: null, // { sectionId, linkId } for edit mode

      // Link Form fields
      linkLabel: "",
      linkUrl: "",
      linkSectionId: "",
      linkSource: "native", // "native" or "inherited"
      linkNewTab: false,

      // Native source date fields
      linkStartDate: new Date(),
      linkEndDate: new Date(),
      linkStartHours: { value: '12', label: '12' },
      linkStartMinutes: { value: '00', label: '00' },
      linkStartState: { value: 'AM', label: 'AM' },
      linkEndHours: { value: '11', label: '11' },
      linkEndMinutes: { value: '59', label: '59' },
      linkEndState: { value: 'PM', label: 'PM' },

      // Inherited source date configuration
      linkDateConfigId: "",

      // Section Modal state
      showSectionModal: false,
      sectionModalMode: "add", // "add" or "edit"
      editingSection: null,
      sectionName: "",

      // Edit change tracking
      originalLinkData: null,
      originalSectionData: null,

      // Date validation error
      dateValidationError: "",

      // Error popup
      errorMsg: false,
      errorMsgShow: "",

      isRemovingSection: false
    };

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.sectionValidator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();

    // Time options for date pickers
    this.hours = [
      { value: '12', label: '12' }, { value: '1', label: '1' }, { value: '2', label: '2' },
      { value: '3', label: '3' }, { value: '4', label: '4' }, { value: '5', label: '5' },
      { value: '6', label: '6' }, { value: '7', label: '7' }, { value: '8', label: '8' },
      { value: '9', label: '9' }, { value: '10', label: '10' }, { value: '11', label: '11' }
    ];

    this.minutes = [
      { value: '00', label: '00' }, { value: '05', label: '05' }, { value: '10', label: '10' },
      { value: '15', label: '15' }, { value: '20', label: '20' }, { value: '25', label: '25' },
      { value: '30', label: '30' }, { value: '35', label: '35' }, { value: '40', label: '40' },
      { value: '45', label: '45' }, { value: '50', label: '50' }, { value: '55', label: '55' }
    ];

    this.timeState = [
      { value: 'AM', label: 'AM' },
      { value: 'PM', label: 'PM' }
    ];
  }

  componentDidMount = () => {
    this.getFooterConfig();
    this.getDateConfigurations();
    this.subscribeToEvents();
  };

  componentWillUnmount = () => {
    if (this.footerSub) this.footerSub.unsubscribe();
    if (this.dateConfigSub) this.dateConfigSub.unsubscribe();
  };

  subscribeToEvents = () => {
    this.footerSub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "admin|Footer|getConfig":
          if (!response.error && response.data && response.data.sections) {
            const sortedSections = response.data.sections
              .map((section) => ({
                ...section,
                links: (section.links || []).sort((a, b) => a.sortIndex - b.sortIndex)
              }))
              .sort((a, b) => a.sortIndex - b.sortIndex);
            this.setState({
              footerSections: sortedSections,
              loaderFlag: false
            });
          } else if (response.error) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: (response.data && response.data.error) || "Failed to fetch footer configuration"
            });
          } else {
            this.setState({
              footerSections: [],
              loaderFlag: false
            });
          }
          break;
        case "admin|Footer|addLink":
          this.setState({ loaderFlag: false });
          if (response.error) {
            this.apiserve.error((response.data && response.data.error) || "Failed to add link");
          } else {
            this.apiserve.success("Link added successfully");
            this.getFooterConfig();
            this.closeModal();
          }
          break;
        case "admin|Footer|editLink":
          this.setState({ loaderFlag: false });
          if (response.error) {
            this.apiserve.error((response.data && response.data.error) || "Failed to update link");
          } else {
            this.apiserve.success("Link updated successfully");
            this.getFooterConfig();
            this.closeModal();
          }
          break;
        case "admin|Footer|removeLink":
          this.setState({ loaderFlag: false });
          if (response.error) {
            this.apiserve.error((response.data && response.data.error) || "Failed to remove link");
          } else {
            this.apiserve.success("Link removed successfully");
            this.getFooterConfig();
          }
          break;
        case "admin|Footer|toggleLink":
          this.setState({ loaderFlag: false });
          if (response.error) {
            this.apiserve.error((response.data && response.data.error) || "Failed to toggle link");
          } else {
            this.getFooterConfig();
          }
          break;
        case "admin|Footer|toggleSection":
          this.setState({ loaderFlag: false });
          if (response.error) {
            this.apiserve.error((response.data && response.data.error) || "Failed to toggle section");
          } else {
            this.getFooterConfig();
          }
          break;
        case "admin|Footer|reorderLinks":
          if (response.error) {
            this.apiserve.error("Failed to reorder links");
          } else {
            this.apiserve.success("Order saved");
          }
          break;
        case "admin|Footer|reorderSections":
          if (response.error) {
            this.apiserve.error("Failed to reorder sections");
          } else {
            this.apiserve.success("Section order saved");
          }
          break;
        case "admin|Footer|saveConfig":
          this.setState({ loaderFlag: false });
          if (response.error) {
            this.apiserve.error((response.data && response.data.error) || "Failed to save footer configuration");
          } else {
            if(this.state.isRemovingSection) {
              this.apiserve.success("Section removed successfully");
              this.setState({ isRemovingSection: false });
            } else {
              this.apiserve.success("Section saved successfully");
            }
            this.getFooterConfig();
            this.closeSectionModal();
          }
          break;
      }
    });
  };

  getFooterConfig = () => {
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("admin|Footer|getConfig", { host: this.props.host });
  };

  getDateConfigurations = () => {
    this.dateConfigSub = this.apiserve.getevent().subscribe((response) => {
      if (response.event === "admin|getDateConfiguration") {
        if (!response.error && response.data) {
          this.setState({
            dateConfigurations: response.data
          });
        }
      }
    });
    this.apiserve.sendevent("admin|getDateConfiguration", { host: this.props.host });
  };

  // ==================== LINK MODAL METHODS ====================

  openAddModal = () => {
    this.setState({
      showModal: true,
      modalMode: "add",
      editingLink: null,
      linkLabel: "",
      linkUrl: "",
      linkSectionId: "",
      linkSource: "native",
      linkNewTab: false,
      linkStartDate: new Date(),
      linkEndDate: new Date(),
      linkStartHours: { value: '12', label: '12' },
      linkStartMinutes: { value: '00', label: '00' },
      linkStartState: { value: 'AM', label: 'AM' },
      linkEndHours: { value: '11', label: '11' },
      linkEndMinutes: { value: '59', label: '59' },
      linkEndState: { value: 'PM', label: 'PM' },
      linkDateConfigId: "",
      dateValidationError: ""
    });
    this.validator.hideMessages();
  };

  openEditModal = (section, link) => {
    // Parse dates from link if they exist
    let startDate = new Date();
    let endDate = new Date();
    let startHours = { value: '12', label: '12' };
    let startMinutes = { value: '00', label: '00' };
    let startState = { value: 'AM', label: 'AM' };
    let endHours = { value: '11', label: '11' };
    let endMinutes = { value: '59', label: '59' };
    let endState = { value: 'PM', label: 'PM' };
    let dateConfigId = "";
    let sourceValue = "native";

    // Normalize source value to lowercase
    if (link.source) {
      sourceValue = link.source.toLowerCase();
    }

    if (link.startDate) {
      startDate = moment(link.startDate).tz("US/Mountain").toDate();
      startHours = { value: moment(link.startDate).tz("US/Mountain").format('h'), label: moment(link.startDate).tz("US/Mountain").format('h') };
      startMinutes = { value: moment(link.startDate).tz("US/Mountain").format('mm'), label: moment(link.startDate).tz("US/Mountain").format('mm') };
      startState = { value: moment(link.startDate).tz("US/Mountain").format('A'), label: moment(link.startDate).tz("US/Mountain").format('A') };
    }

    if (link.endDate) {
      endDate = moment(link.endDate).tz("US/Mountain").toDate();
      endHours = { value: moment(link.endDate).tz("US/Mountain").format('h'), label: moment(link.endDate).tz("US/Mountain").format('h') };
      endMinutes = { value: moment(link.endDate).tz("US/Mountain").format('mm'), label: moment(link.endDate).tz("US/Mountain").format('mm') };
      endState = { value: moment(link.endDate).tz("US/Mountain").format('A'), label: moment(link.endDate).tz("US/Mountain").format('A') };
    }

    // Parse sourceRef for inherited links
    // Format could be "dateConfiguration:<id>" or just the raw ID
    if (sourceValue === "inherited" && link.sourceRef) {
      if (link.sourceRef.includes(':')) {
        // Format: "dateConfiguration:<id>"
        const parts = link.sourceRef.split(':');
        if (parts.length === 2 && parts[0] === 'dateConfiguration') {
          dateConfigId = parts[1];
        }
      } else {
        // Format: raw ID
        dateConfigId = link.sourceRef;
      }
    }

    this.setState({
      showModal: true,
      modalMode: "edit",
      editingLink: { sectionId: section._id, linkId: link._id },
      linkLabel: link.label,
      linkUrl: link.url,
      linkSectionId: section.name,
      linkSource: sourceValue,
      linkNewTab: link.openInNewTab || false,
      linkStartDate: startDate,
      linkEndDate: endDate,
      linkStartHours: startHours,
      linkStartMinutes: startMinutes,
      linkStartState: startState,
      linkEndHours: endHours,
      linkEndMinutes: endMinutes,
      linkEndState: endState,
      linkDateConfigId: dateConfigId,
      originalLinkData: {
        linkLabel: link.label,
        linkUrl: link.url,
        linkSource: sourceValue,
        linkNewTab: link.openInNewTab || false,
        linkStartDate: startDate,
        linkStartHours: startHours,
        linkStartMinutes: startMinutes,
        linkStartState: startState,
        linkEndDate: endDate,
        linkEndHours: endHours,
        linkEndMinutes: endMinutes,
        linkEndState: endState,
        linkDateConfigId: dateConfigId
      }
    });
    this.validator.hideMessages();
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      modalMode: "add",
      editingLink: null,
      linkLabel: "",
      linkUrl: "",
      linkSectionId: "",
      linkSource: "native",
      linkNewTab: false,
      linkStartDate: new Date(),
      linkEndDate: new Date(),
      linkStartHours: { value: '12', label: '12' },
      linkStartMinutes: { value: '00', label: '00' },
      linkStartState: { value: 'AM', label: 'AM' },
      linkEndHours: { value: '11', label: '11' },
      linkEndMinutes: { value: '59', label: '59' },
      linkEndState: { value: 'PM', label: 'PM' },
      linkDateConfigId: "",
      dateValidationError: "",
      originalLinkData: null
    });
    this.validator.hideMessages();
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleCheckboxChange = (e) => {
    this.setState({
      [e.target.name]: e.target.checked
    });
  };

  handleDateChange = (date, field) => {
    this.setState({ [field]: date, dateValidationError: "" });
  };

  handleTimeChange = (value, field) => {
    this.setState({ [field]: value, dateValidationError: "" });
  };

  getMtTime = (date, hours, minutes, state) => {
    const ABBR = moment.tz("America/Denver").format("z");
    const offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
    const hourValue = state.value === 'PM' || state.value === 'pm'
      ? (parseInt(hours.value) === 12 ? 12 : parseInt(hours.value) + 12)
      : (parseInt(hours.value) === 12 ? 0 : parseInt(hours.value));
    return moment(date).hour(hourValue).minute(minutes.value).add(offDifference, 'minutes').toISOString();
  };

  submitModal = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const url = this.state.linkUrl.trim();
      const allowedSchemes = ['http://', 'https://', '/', 'mailto:', 'tel:'];
      const hasValidScheme = allowedSchemes.some(scheme => url.toLowerCase().startsWith(scheme));

      if (!hasValidScheme) {
        this.apiserve.error("URL must start with http://, https://, /, mailto:, or tel:");
        return;
      }

      // Validate start date is not greater than end date (only for native source)
      if (this.state.linkSource === "native") {
        const startMt = this.getMtTime(this.state.linkStartDate, this.state.linkStartHours, this.state.linkStartMinutes, this.state.linkStartState);
        const endMt = this.getMtTime(this.state.linkEndDate, this.state.linkEndHours, this.state.linkEndMinutes, this.state.linkEndState);
        if (new Date(startMt) >= new Date(endMt)) {
          this.setState({ dateValidationError: "End Date & Time must be after Start Date & Time" });
          return;
        }
      }

      this.setState({ loaderFlag: true });

      let startDate = null;
      let endDate = null;
      let sourceRef = null;

      if (this.state.linkSource === "native") {
        startDate = this.getMtTime(this.state.linkStartDate, this.state.linkStartHours, this.state.linkStartMinutes, this.state.linkStartState);
        endDate = this.getMtTime(this.state.linkEndDate, this.state.linkEndHours, this.state.linkEndMinutes, this.state.linkEndState);
        sourceRef = null;
      } else {
        // For Inherited, use the selected dateConfiguration's dates
        const selectedConfig = this.state.dateConfigurations.find((c) => c._id === this.state.linkDateConfigId);
        if (selectedConfig) {
          startDate = selectedConfig.footerStartDate;
          endDate = selectedConfig.footerEndDate;
          sourceRef = selectedConfig._id;
        }
      }

      if (this.state.modalMode === "add") {
        const selectedSection = this.state.footerSections.find((s) => s.name === this.state.linkSectionId);
        const sectionId = selectedSection ? selectedSection._id : this.state.linkSectionId;
        this.apiserve.sendevent("admin|Footer|addLink", {
          host: this.props.host,
          sectionId: sectionId,
          label: this.state.linkLabel,
          url: url,
          openInNewTab: this.state.linkNewTab,
          source: this.state.linkSource,
          sourceRef: sourceRef,
          startDate: startDate,
          endDate: endDate,
          isActive: true
        });
      } else {
        const { editingLink } = this.state;
        this.apiserve.sendevent("admin|Footer|editLink", {
          host: this.props.host,
          sectionId: editingLink.sectionId,
          linkId: editingLink.linkId,
          label: this.state.linkLabel,
          url: url,
          openInNewTab: this.state.linkNewTab,
          source: this.state.linkSource,
          sourceRef: sourceRef,
          startDate: startDate,
          endDate: endDate,
        });
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  removeLink = (sectionId, link) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this link",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loaderFlag: true });
        this.apiserve.sendevent("admin|Footer|removeLink", {
          host: this.props.host,
          sectionId: sectionId,
          linkId: link._id
        });
      }
    });
  };

  toggleLink = (sectionId, linkId, isActive) => {
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("admin|Footer|toggleLink", {
      host: this.props.host,
      sectionId: sectionId,
      linkId: linkId,
      isActive: !isActive
    });
  };

  toggleSection = (sectionId, isActive) => {
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("admin|Footer|toggleSection", {
      host: this.props.host,
      sectionId: sectionId,
      isActive: !isActive
    });
  };

  // ==================== DRAG AND DROP ====================
  // Only handles link reordering within sections
  onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) return;
    if (source.index === destination.index && source.droppableId === destination.droppableId) return;

    // Handle section reordering
    if (destination.droppableId === 'sections') {
      const sections = Array.from(this.state.footerSections);
      const [moved] = sections.splice(source.index, 1);
      sections.splice(destination.index, 0, moved);

      sections.forEach((sec, idx) => {
        sec.sortIndex = idx;
      });

      this.setState({ footerSections: sections }, () => {
        const order = sections.map((sec) => ({
          sectionId: sec._id,
          sortIndex: sec.sortIndex
        }));
        this.apiserve.sendevent("admin|Footer|reorderSections", {
          host: this.props.host,
          order: order
        });
      });
      return;
    }

    // Handle link reordering (droppableId starts with 'links-')
    if (destination.droppableId.startsWith('links-')) {
      const sectionId = destination.droppableId.replace('links-', '');
      const sectionIndex = this.state.footerSections.findIndex((s) => s._id === sectionId);
      if (sectionIndex === -1) return;

      const links = Array.from(this.state.footerSections[sectionIndex].links);
      const [moved] = links.splice(source.index, 1);
      links.splice(destination.index, 0, moved);

      links.forEach((link, idx) => {
        link.sortIndex = idx;
      });

      const sections = [...this.state.footerSections];
      sections[sectionIndex] = { ...sections[sectionIndex], links };
      this.setState({ footerSections: sections }, () => {
        const order = links.map((link) => ({
          linkId: link._id,
          sortIndex: link.sortIndex
        }));
        this.apiserve.sendevent("admin|Footer|reorderLinks", {
          host: this.props.host,
          sectionId: sectionId,
          order: order
        });
      });
    }
  };

  // ==================== SECTION MODAL METHODS ====================

  openAddSectionModal = () => {
    if (this.state.footerSections.length >= MAX_SECTIONS) {
      this.apiserve.error(`Maximum ${MAX_SECTIONS} sections allowed`);
      return;
    }
    this.setState({
      showSectionModal: true,
      sectionModalMode: "add",
      editingSection: null,
      sectionName: ""
    });
    this.sectionValidator.hideMessages();
  };

  openEditSectionModal = (section) => {
    this.setState({
      showSectionModal: true,
      sectionModalMode: "edit",
      editingSection: section,
      sectionName: section.name,
      originalSectionData: { sectionName: section.name }
    });
    this.sectionValidator.hideMessages();
  };

  closeSectionModal = () => {
    this.setState({
      showSectionModal: false,
      sectionModalMode: "add",
      editingSection: null,
      sectionName: "",
      originalSectionData: null
    });
    this.sectionValidator.hideMessages();
  };

  submitSectionModal = (e) => {
    e.preventDefault();
    if (this.sectionValidator.allValid()) {
      this.setState({ loaderFlag: true });

      const { sectionModalMode, editingSection, sectionName, footerSections } = this.state;

      let updatedSections;
      if (sectionModalMode === "add") {
        const newSection = {
          name: sectionName,
          identifier: sectionName.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
          isActive: true,
          links: [],
          sortIndex: footerSections.length
        };
        updatedSections = [...footerSections, newSection];
      } else {
        updatedSections = footerSections.map((section) => {
          if (section._id === editingSection._id) {
            return {
              ...section,
              name: sectionName,
              identifier: sectionName.toLowerCase().replace(/[^a-z0-9]+/g, '-')
            };
          }
          return section;
        });
      }

      this.apiserve.sendevent("admin|Footer|saveConfig", {
        host: this.props.host,
        sections: updatedSections
      });
    } else {
      this.sectionValidator.showMessages();
      this.forceUpdate();
    }
  };

  deleteSection = (section) => {
    swal({
      title: "Are you sure?",
      text: `You want to delete the "${section.name}" section. This will also delete all links in this section.`,
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loaderFlag: true, isRemovingSection: true });
        const updatedSections = this.state.footerSections.filter((s) => s._id !== section._id);
        updatedSections.forEach((section, idx) => {
          section.sortIndex = idx;
        });
        this.apiserve.sendevent("admin|Footer|saveConfig", {
          host: this.props.host,
          sections: updatedSections
        });
      }
    });
  };

  dismissError = () => {
    this.setState({
      errorMsg: false
    });
  };

  // ==================== RENDER ====================

  render() {
    this.validator.purgeFields();
    const {
      footerSections,
      showModal,
      modalMode,
      linkLabel,
      linkUrl,
      linkSectionId,
      linkSource,
      linkNewTab,
      linkStartDate,
      linkEndDate,
      linkStartHours,
      linkStartMinutes,
      linkStartState,
      linkEndHours,
      linkEndMinutes,
      linkEndState,
      linkDateConfigId,
      showSectionModal,
      sectionModalMode,
      sectionName,
      dateConfigurations,
      originalLinkData,
      originalSectionData
    } = this.state;

    const sectionOptions = footerSections.map((s) => s.name);
    const sourceOptions = [
      { id: "native", name: "Native" },
      { id: "inherited", name: "Inherited" }
    ];
    const canAddSection = footerSections.length < MAX_SECTIONS;

    // Date configuration options for inherited source
    const dateConfigOptions = dateConfigurations.map((config) => ({
      value: config._id,
      label: config.module.replace(/_/g, ' ')
    }));

    // Change detection for edit mode
    const hasLinkChanges = modalMode === "edit" && originalLinkData && (
      linkLabel !== originalLinkData.linkLabel ||
      linkUrl !== originalLinkData.linkUrl ||
      linkSource !== originalLinkData.linkSource ||
      linkNewTab !== originalLinkData.linkNewTab ||
      linkDateConfigId !== originalLinkData.linkDateConfigId ||
      linkStartDate.getTime() !== originalLinkData.linkStartDate.getTime() ||
      linkEndDate.getTime() !== originalLinkData.linkEndDate.getTime() ||
      linkStartHours.value !== originalLinkData.linkStartHours.value ||
      linkStartMinutes.value !== originalLinkData.linkStartMinutes.value ||
      linkStartState.value !== originalLinkData.linkStartState.value ||
      linkEndHours.value !== originalLinkData.linkEndHours.value ||
      linkEndMinutes.value !== originalLinkData.linkEndMinutes.value ||
      linkEndState.value !== originalLinkData.linkEndState.value
    );
    const hasSectionChanges = sectionModalMode === "edit" && originalSectionData &&
      sectionName !== originalSectionData.sectionName;

    return (
      <div className="footer_config_wrapper">
        <div className="ticketing_content">
          {/* Header with Add Section and Add Link buttons */}
          <div className="footer_config_header d_flex d_flex_align_center d_flex_justify_spacebt">
            <div></div>
            <div className="footer_config_actions">
              <button
                className={`sd_update_list_btn ${!canAddSection ? 'disabled' : ''}`}
                onClick={this.openAddSectionModal}
                type="button"
                disabled={!canAddSection}
                title={!canAddSection ? `Maximum ${MAX_SECTIONS} sections allowed` : ''}
              >
                + Add Section
              </button>
              <button
                className="sd_update_list_btn"
                onClick={this.openAddModal}
                type="button"
              >
                + Add Footer Link
              </button>
            </div>
          </div>

          {/* Footer Sections Table with Accordion */}
          <div className="table_wrap product_list_tbl date_congiguration footer_config_table">
            {footerSections.length === 0 ? (
              <p className="no_data_msg">No footer sections configured</p>
            ) : (
              <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>

              <Droppable droppableId="sections" direction="vertical">
                  {(secDropProvided) => (
                    <div ref={secDropProvided.innerRef} {...secDropProvided.droppableProps}>
                      <Accordion allowZeroExpanded={true}>
                        {footerSections.map((section, index) => (
                          <Draggable key={section._id} draggableId={`section-${section._id}`} index={index} isDragDisabled={section.name === "My Festival"}>
                            {(secDragProvided, secSnapshot) => {
                              const isFestivalSection = section.name === "My Festival";
                              return (
                              <div
                                ref={secDragProvided.innerRef}
                                {...secDragProvided.draggableProps}
                                className={`${secSnapshot.isDragging ? "is_dragging" : ""} ${isFestivalSection ? "festival_readonly" : ""}`}
                              >
                                <AccordionItem>
                                  <div className="sd_mobile_mobiscroll_block film_list_table striped_table">
                                    <AccordionItemHeading className="main_heading">
                                      <AccordionItemButton>
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                {!isFestivalSection && (
                                                  <span
                                                  {...secDragProvided.dragHandleProps}
                                                    className="drag_handle"
                                                    aria-label="Drag to reorder section"
                                                  >
                                                    <DraggerIcon />
                                                  </span>
                                                )}
                                              </td>
                                              <td>{section.name}</td>
                                              <td>{(section.links || []).length} links</td>
                                              <td>
                                                {!isFestivalSection && (
                                                  <label className="switch switch--small" onClick={(e) => e.stopPropagation()}>
                                                    <input
                                                      type="checkbox"
                                                      checked={section.isActive}
                                                      onChange={() => this.toggleSection(section._id, section.isActive)}
                                                      aria-label={`Toggle ${section.name}`}
                                                    />
                                                    <span className="slider round"></span>
                                                  </label>
                                                )}
                                              </td>
                                              <td>
                                                {!isFestivalSection && (
                                                  <>
                                                    <span className="pointer" onClick={(e) => { e.stopPropagation(); this.openEditSectionModal(section); }}>
                                                      <EditIcon />
                                                    </span>
                                                    <span className="pointer" onClick={(e) => { e.stopPropagation(); this.deleteSection(section); }}>
                                                      <DeleteIcon />
                                                    </span>
                                                  </>
                                                )}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                      {(!section.links || section.links.length === 0) ? (
                                        <p className="no_links_msg">No links in this section</p>
                                      ) : (
                                        <Droppable droppableId={`links-${section._id}`} direction="vertical">
                                          {(linkDropProvided) => (
                                            <table>
                                              <tbody ref={linkDropProvided.innerRef} {...linkDropProvided.droppableProps}>
                                                {section.links.map((link, linkIndex) => (
                                                  <Draggable key={link._id} draggableId={link._id} index={linkIndex} isDragDisabled={isFestivalSection}>
                                                    {(linkDragProvided, linkSnapshot) => (
                                                      <tr
                                                        ref={linkDragProvided.innerRef}
                                                        {...linkDragProvided.draggableProps}
                                                        className={`footer_link_row ${linkSnapshot.isDragging ? "is_dragging" : ""}`}
                                                      >
                                                        <td>
                                                          {!isFestivalSection && (
                                                            <span
                                                              {...linkDragProvided.dragHandleProps}
                                                              className="drag_handle"
                                                              aria-label="Drag to reorder"
                                                            >
                                                              <DraggerIcon />
                                                            </span>
                                                          )}
                                                        </td>
                                                        <td>{link.label}</td>
                                                        <td className="link_url_cell">
                                                          {link.url}
                                                          {link.source === "inherited" && (
                                                            <span className="link_source_badge">{link.source}</span>
                                                          )}
                                                        </td>
                                                        <td>
                                                          {!isFestivalSection && (
                                                            <label className="switch switch--small">
                                                              <input
                                                                type="checkbox"
                                                                checked={link.isActive}
                                                                onChange={() => this.toggleLink(section._id, link._id, link.isActive)}
                                                                aria-label={`Toggle ${link.label}`}
                                                              />
                                                              <span className="slider round"></span>
                                                            </label>
                                                          )}
                                                        </td>
                                                        <td>
                                                          {!isFestivalSection && (
                                                            <>
                                                              <span className="pointer" onClick={() => this.openEditModal(section, link)}>
                                                                <EditIcon />
                                                              </span>
                                                              <span className="pointer" onClick={() => this.removeLink(section._id, link)}>
                                                                <DeleteIcon />
                                                              </span>
                                                            </>
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </Draggable>
                                                ))}
                                                {linkDropProvided.placeholder}
                                              </tbody>
                                            </table>
                                          )}
                                        </Droppable>
                                      )}
                                    </AccordionItemPanel>
                                  </div>
                                </AccordionItem>
                              </div>
                            );}}
                          </Draggable>
                        ))}
                      </Accordion>
                     {secDropProvided.placeholder}
                   </div>
                  )}
                </Droppable>
                </DragDropContext>
            )}
          </div>
        </div>

        {/* Loader */}
        {this.state.loaderFlag ? <Loader /> : ""}

        {/* Add/Edit Link Modal */}
        {showModal && (
          <div className={`user_popup active`}>
            <span className="popup_overlay" onClick={this.closeModal}></span>
            <div className="cat_modal_inner sd_hf_modal">
              <p className="cat_title text_center">
                {modalMode === "add" ? "Add Footer Link" : "Edit Footer Link"}
              </p>
              <form onSubmit={this.submitModal}>
                <div className="field_row">
                  <TextField
                    type="text"
                    name="linkLabel"
                    label="Link Name"
                    value={linkLabel}
                    onChange={this.handleInputChange}
                    fpgerror={this.validator.message("Link Name", linkLabel, "required")}
                  />
                </div>
                <div className="field_row">
                  <TextField
                    type="text"
                    name="linkUrl"
                    label="Link URL"
                    value={linkUrl}
                    onChange={this.handleInputChange}
                    fpgerror={this.validator.message("Link URL", linkUrl, "required|url")}
                  />
                </div>
                {modalMode === "add" && (
                  <div className="field_row">
                    <Dropdown
                      name="linkSectionId"
                      label="Section"
                      options={sectionOptions}
                      value={linkSectionId}
                      onChange={this.handleInputChange}
                      DefaultOption="Select Section"
                    />
                    <span style={{ color: "red" }}>
                      {this.validator.message("Section", linkSectionId, "required")}
                    </span>
                  </div>
                )}
                <div className="field_row">
                  <div className="field_row_inner">
                    <label>Source Type</label>
                    <div className="select_field relative">
                      <select name="linkSource" onChange={this.handleInputChange} value={linkSource}>
                        <option disabled value="">Select Source</option>
                        {sourceOptions.map((opt) => (
                          <option key={opt.id} value={opt.id}>{opt.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Conditional UI based on source type */}
                {linkSource === "native" ? (
                  <>
                    {/* Start Date & Time */}
                    <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                      <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                        <label>Start Date & Time (MT)</label>
                        <div className="form_group_countdown">
                          <>
                            <TextField
                              type="text"
                              name="startDateDisplay"
                              value={moment(linkStartDate).format("MM/DD/YYYY")}
                              placeholder="mm / dd / yyyy"
                            />
                            <span className="calendar_img">
                              <DatePicker
                                selected={linkStartDate}
                                onChange={(date) => this.handleDateChange(date, 'linkStartDate')}
                                minDate={moment().tz("US/Mountain").toDate()}
                                placeholder="mm/dd/yyyy"
                                customInput={
                                  <span className="calendar">
                                    <CalendarIcon />
                                  </span>
                                }
                              />
                            </span>
                            <Select
                              options={this.hours}
                              value={linkStartHours}
                              name='linkStartHours'
                              placeholder="12"
                              onChange={(e) => this.handleTimeChange(e, 'linkStartHours')}
                            />
                            <Select
                              options={this.minutes}
                              value={linkStartMinutes}
                              name='linkStartMinutes'
                              placeholder="00"
                              onChange={(e) => this.handleTimeChange(e, 'linkStartMinutes')}
                            />
                            <Select
                              options={this.timeState}
                              value={linkStartState}
                              name='linkStartState'
                              placeholder="AM"
                              onChange={(e) => this.handleTimeChange(e, 'linkStartState')}
                            />
                          </>
                        </div>
                      </div>
                    </div>

                    {/* End Date & Time */}
                    <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                      <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                        <label>End Date & Time (MT)</label>
                        <div className="form_group_countdown">
                          <>
                            <TextField
                              type="text"
                              name="endDateDisplay"
                              value={moment(linkEndDate).format("MM/DD/YYYY")}
                              placeholder="mm / dd / yyyy"
                            />
                            <span className="calendar_img">
                              <DatePicker
                                selected={linkEndDate}
                                onChange={(date) => this.handleDateChange(date, 'linkEndDate')}
                                minDate={moment(linkStartDate).toDate()}
                                placeholder="mm/dd/yyyy"
                                customInput={
                                  <span className="calendar">
                                    <CalendarIcon />
                                  </span>
                                }
                              />
                            </span>
                            <Select
                              options={this.hours}
                              value={linkEndHours}
                              name='linkEndHours'
                              placeholder="11"
                              onChange={(e) => this.handleTimeChange(e, 'linkEndHours')}
                            />
                            <Select
                              options={this.minutes}
                              value={linkEndMinutes}
                              name='linkEndMinutes'
                              placeholder="59"
                              onChange={(e) => this.handleTimeChange(e, 'linkEndMinutes')}
                            />
                            <Select
                              options={this.timeState}
                              value={linkEndState}
                              name='linkEndState'
                              placeholder="PM"
                              onChange={(e) => this.handleTimeChange(e, 'linkEndState')}
                            />
                          </>
                        </div>
                      </div>
                    </div>
                    {this.state.dateValidationError && (
                      <span style={{ color: 'red', fontSize: '13px', display: 'block', marginBottom: '10px' }}>
                        {this.state.dateValidationError}
                      </span>
                    )}
                  </>
                ) : (
                  /* Inherited - Date Configuration Dropdown */
                  <div className="field_row">
                    <label>Date Configuration</label>
                    <Select
                      options={dateConfigOptions}
                      value={dateConfigOptions.find((o) => o.value === linkDateConfigId) || null}
                      onChange={(option) => this.setState({ linkDateConfigId: option ? option.value : "" })}
                      placeholder="Select Date Configuration"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isDisabled={dateConfigOptions.length === 0}
                    />
                    <span style={{ color: "red" }}>
                      {this.validator.message("Date Configuration", linkDateConfigId, "required")}
                    </span>
                  </div>
                )}

                <div className="field_row">
                  <CheckBox
                    label="Open in New Tab"
                    type="checkbox"
                    id="linkNewTab"
                    name="linkNewTab"
                    checked={linkNewTab}
                    onChange={this.handleCheckboxChange}
                  />
                </div>
                <div className="cat_btns text_center">
                  <button type="button" onClick={this.closeModal}>
                    CANCEL
                  </button>
                  <button className={modalMode === "edit" && !hasLinkChanges ? "" : "active"} type="submit" disabled={modalMode === "edit" && !hasLinkChanges}>
                    {modalMode === "add" ? "SAVE" : "UPDATE"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Add/Edit Section Modal - Only Section Name */}
        {showSectionModal && (
          <div className={`user_popup active`}>
            <span className="popup_overlay" onClick={this.closeSectionModal}></span>
            <div className="cat_modal_inner sd_hf_modal">
              <p className="cat_title text_center">
                {sectionModalMode === "add" ? "Add Footer Section" : "Edit Footer Section"}
              </p>
              <form onSubmit={this.submitSectionModal}>
                <div className="field_row">
                  <TextField
                    type="text"
                    name="sectionName"
                    label="Section Name"
                    value={sectionName}
                    onChange={this.handleInputChange}
                    fpgerror={this.sectionValidator.message("Section Name", sectionName, "required")}
                  />
                </div>
                <div className="cat_btns text_center">
                  <button type="button" onClick={this.closeSectionModal}>
                    CANCEL
                  </button>
                  <button className={sectionModalMode === "edit" && !hasSectionChanges ? "" : "active"} type="submit" disabled={sectionModalMode === "edit" && !hasSectionChanges}>
                    {sectionModalMode === "add" ? "SAVE" : "UPDATE"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Error Popup */}
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn active" onClick={this.dismissError}>
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FooterConfiguration;
